import { Form, Input } from '@/components/form';
import { Flex } from '@/components/layouting';
import { FormattedMessage, useIntl } from '@/components/formatted_message/FormattedMessage';
import { Typography } from '@/components/typography';
import { ButtonAnt } from '@/components/buttons/button/ButtonAnt';
import { Page as messages } from '../messages';
import type { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { TRANSLATED_ACTIONS } from '@/common/messages';
import { APP_DICTIONARY } from '@/common/messages/root';
import { Icon } from '@/components/icon';

const PASSWORD_FORM_ID = 'password-form';

const { Headline } = Typography;

interface PasswordFormValues {
  password: string;
}

interface PasswordContentProps {
  onContinue: (password: string) => void;
}

export const PasswordContent: FC<PasswordContentProps> = ({ onContinue }) => {
  const intl = useIntl();
  const [form] = Form.useForm<PasswordFormValues>();
  const history = useHistory();

  const INITIAL_VALUES: PasswordFormValues = {
    password: '',
  };

  const handleSubmit = ({ password }: PasswordFormValues) => {
    onContinue(password);
  };

  const handleBack = () => {
    history.push('/');
  };

  return (
    <Form id={PASSWORD_FORM_ID} form={form} onFinish={handleSubmit} initialValues={INITIAL_VALUES} layout="vertical">
      <Flex gap={24} vertical>
        <Flex gap={16} vertical>
          <Headline>
            <FormattedMessage {...messages.passwordAgainTitle} />
          </Headline>

          <Form.Item
            label={intl.formatMessage(APP_DICTIONARY.password)}
            name="password"
            required
            style={{ marginBottom: 0 }}
          >
            <Input.Password
              autoFocus
              data-cy="login-password"
              data-test="login-password"
              iconRender={visible => <Icon iconString={visible ? 'eye' : 'eyeSlash'} style={{ cursor: 'pointer' }} />}
              placeholder={intl.formatMessage(APP_DICTIONARY.password)}
            />
          </Form.Item>

          <Flex gap={8} vertical>
            <ButtonAnt
              block
              data-cy="password-continue-button"
              form={PASSWORD_FORM_ID}
              htmlType="submit"
              size="large"
              type="primary"
            >
              <FormattedMessage {...TRANSLATED_ACTIONS.continue} />
            </ButtonAnt>
            <ButtonAnt block data-cy="password-back-button" onClick={handleBack} size="large">
              <FormattedMessage {...messages.back} />
            </ButtonAnt>
          </Flex>
        </Flex>
      </Flex>
    </Form>
  );
};
